import api, {privateApi} from 'utils/api'

export const userProfile = async (payload: any) => {
    const rawPayload = JSON.stringify(payload, null, 4);
    const finalPayload = JSON.stringify(rawPayload);
    return await api.post(
        '/cps/v1/userregister',
        finalPayload
    );
};

export const branchProfile = async (payload) => await api.post('/cps/v1/registerbranchprofile', payload)

export const branchRelationship = async (payload) => await api.post('/cps/v1/registerbranchrelationship', payload)

export const branchAccount = async (payload) => await api.post('/cps/v1/registerbranchaccount', payload)

export const inviteCoworkers = async (payload) => await api.post('/cps/v1/invitecoworkers', payload)

export const createNewBranch = async (payload) => await api.post('/cps/v1/registernewbranch', payload)

export const isUserExists = async (payload) => await api.get(`/cps/v1/isUserExists?email=${payload}`)

export const isInviteCoworkerEmailExists = async (payload) =>
    await api.get(`/cps/v1/isMailExists?email=${payload}`)

export const userRegisterBranchAdmin = async (payload) =>
    await privateApi.post('/cps/v1/userregisterbranchadmin', payload)

export const contact = async (payload) =>
    await api.post('/cps/v1/contactUs', payload, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })

export const requestDemoApi = async (payload) => await api.post('/cps/v1/requestDemo', payload)

export const guestRegistrationApi = async (payload) => await api.post('/cps/v1/guestuserregistration', payload)

export const guestSecurityCode = async (payload) => await api.post('/cps/v1/verifyGuestSecurityCode', payload)

export const resendSecurityCodeApi = async (payload) => await api.post('/cps/v1/resendguestotp', payload)
